import * as THREE from 'three'
import { ProtoBase } from '../ProtoBase'
import { SITES, MITAKA_XZ, type KanjinSite } from '../kanjinData'

/** ⑨ 勧進帳連動 — 木片が届くたび、手元の勧進帳に朱印が灯る */
export class Proto9 extends ProtoBase {
  readonly title = '9. 勧進帳連動'
  readonly desc = '到着のたびに勧進帳へ朱印。集める快感と見せ場を接続する'

  private queue: KanjinSite[] = []
  private next = 0
  private timer = 0
  private doneT = 0

  protected start(): void {
    this.ctx.setWorld('map')
    this.ctx.setLedger(true)
    this.ctx.resetLedger()
    this.ctx.setCaption('聞いた物語は、勧進帳に集まってゆく')
    this.queue = [...SITES]
    this.next = 0
    this.timer = 1
    this.ctx.chips.onArrive = (site) => {
      if (!site) return
      this.ctx.stampLedger(site.no)
      this.ctx.sfx.play('stamp')
      this.ctx.markers.highlight(site.no, 1)
    }
  }

  update(dt: number): void {
    this.elapsed += dt
    this.timer -= dt
    if (this.next < this.queue.length && this.timer <= 0) {
      this.timer = 1.4
      const site = this.queue[this.next++]
      const from = new THREE.Vector3()
      this.ctx.markers.topOf(site.no, from)
      this.ctx.chips.launch({
        from,
        to: new THREE.Vector3(MITAKA_XZ.x, 1.2, MITAKA_XZ.z),
        dur: 3.2,
        apex: 16,
        site,
      })
    }
    if (this.next >= this.queue.length && this.ctx.chips.activeCount === 0 && this.doneT === 0) {
      this.doneT = this.elapsed
      this.ctx.setCaption('十二の朱印——六十六人の勧進、八十九の木片')
    }
    if (this.doneT > 0 && this.elapsed - this.doneT > 6) {
      this.doneT = 0
      this.next = 0
      this.timer = 1
      this.ctx.resetLedger()
      this.ctx.markers.clearHighlights()
      this.ctx.chips.clear()
    }
  }

  protected onDispose(): void {
    this.ctx.chips.onArrive = undefined
    this.ctx.chips.clear()
    this.ctx.setLedger(false)
    this.ctx.markers.clearHighlights()
  }
}
